import UserLogin from 'components/form/user/UserLogin';
import React from 'react';

export default function Login() {
  return <UserLogin />;
}
